<template>
  <div class="edit-wrap">
    <div class="item-card">
      <div class="card-title">投放内容</div>
      <div class="card-content">
        <ul class="modal-form">
          <el-form :model="tfContent" :rules="rules" ref="tfcontentRef">
            <li class="form-item">
              <span class="form-label require" style="padding-top: 6px">广告计划名称：</span>
              <div class="form-value">
                <el-form-item prop="name_rule" style="margin-bottom: 0px">
                  <el-input v-model="tfContent.name_rule" placeholder="(必填)请输入广告计划名称"></el-input>
                </el-form-item>
                <ul class="name-list">
                  <li
                    v-for="(item, index) of showAdList"
                    :key="index"
                    :class="['name-item', selectItem.indexOf(index) === -1 ? '' : 'cur']"
                    @click="handleSelectItem(item, index)"
                  >
                    {{ item }}
                  </li>
                  <li class="show-more">
                    <span v-show="!showMore" @click="showMore = true">更多<i class="el-icon-arrow-down"></i></span>
                    <span v-show="showMore" @click="showMore = false">收起<i class="el-icon-arrow-up"></i></span>
                  </li>
                </ul>
              </div>
            </li>
            <li class="form-item">
              <span class="form-label">下载方式：</span>
              <div class="form-value">
                <el-radio-group v-model="tfContent.download_type">
                  <el-radio label="DOWNLOAD_URL">下载链接</el-radio>
                </el-radio-group>
              </div>
            </li>
            <li class="form-item">
              <span class="form-label">投放目标：</span>
              <div class="form-value">
                <el-radio-group v-model="tfContent.pricing">
                  <el-radio label="PRICING_OCPM">转化量</el-radio>
                </el-radio-group>
              </div>
            </li>
            <li class="form-item">
              <span class="form-label require" style="padding-top: 6px">转化目标：</span>
              <div class="form-value">
                <el-form-item prop="convert_type" style="margin-bottom: 0px">
                  <el-select v-model="tfContent.convert_type" placeholder="(必填)请选择" @change="(val) => changeTarget(val, true)">
                    <el-option
                      v-for="item of converDataList"
                      :key="item.externalAction"
                      :label="item.optimization_name"
                      :value="item.externalAction"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </div>
            </li>
            <li class="form-item">
              <span class="form-label require" style="padding-top: 6px">深度转化目标：</span>
              <div class="form-value">
                <el-form-item prop="deep_external_action" style="margin-bottom: 0px">
                  <el-select v-model="tfContent.deep_external_action" placeholder="(必填)请选择">
                    <el-option label="无" value="NONE"></el-option>
                    <el-option
                      v-for="item of deepConverList"
                      :key="item.deepExternalAction"
                      :label="item.optimizationName"
                      :value="item.deepExternalAction"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </div>
            </li>
            <!-- <li class="form-item">
              <span class="form-label" style="padding-top: 6px"
                >转化跟踪：</span
              >
              <div class="form-value">
                <el-radio-group v-model="tfContent.flowType" size="small">
                  <el-radio-button :label="0">分别配置</el-radio-button>
                  <el-radio-button :label="1">统一配置</el-radio-button>
                </el-radio-group>
                <div class="flow-table-wrap">
                  <div class="part-conf" v-show="tfContent.flowType === 0">
                    <el-table
                      :data="followData"
                      class="flow-table"
                      size="small"
                    >
                      <el-table-column prop="date" label="广告账户">
                        <template slot-scope="scope">
                          <div class="ad-col">
                            <div>
                              {{ scope.row[0].advertiserName }}
                            </div>
                            <div>ID: {{ scope.row[0].advertiserId }}</div>
                          </div>
                        </template>
                      </el-table-column>
                      <el-table-column prop="name" label="转化跟踪">
                        <template slot="header">
                          <div class="header-wrap">
                            <span>转化跟踪</span>
                            <span
                              class="transfor-manage"
                              @click="transforManage"
                              >转化管理</span
                            >
                          </div>
                        </template>
                        <template slot-scope="scope">
                          <el-select
                            placeholder="请选择"
                            v-model="scope.row[0].selectVal"
                            @change="setDownloadUrl"
                          >
                            <el-option
                              v-for="item in scope.row[1]"
                              :key="item.convert_id"
                              :label="item.name"
                              :value="item.convert_id"
                            >
                            </el-option>
                          </el-select>
                        </template>
                      </el-table-column>
                    </el-table>
                  </div>
                  <div class="uni-conf" v-show="tfContent.flowType !== 0">
                    <el-select
                      placeholder="请选择"
                      v-model="uniSelect"
                      @change="setDownloadUrl"
                    >
                      <el-option
                        v-for="item in allOptions"
                        :key="item.convert_id"
                        :label="item.name"
                        :value="item.convert_id"
                      >
                      </el-option>
                    </el-select>
                  </div>
                </div>
              </div>
            </li> -->
            <!-- <li class="form-item">
              <span class="form-label require" style="padding-top: 6px"
                >下载链接：</span
              >
              <div class="form-value">
                <el-form-item prop="download_url" style="margin-bottom: 0px">
                  <el-input
                    style="width: 255px"
                    v-model="tfContent.download_url"
                  ></el-input>
                </el-form-item>
              </div>
            </li> -->
            <li class="form-item">
              <span class="form-label require" style="padding-top: 6px">应用包名：</span>
              <div class="form-value">
                <el-form-item prop="package_name" style="margin-bottom: 0px">
                  <el-input
                    style="width: 255px"
                    v-model="tfContent.package_name"
                    :disabled="true"
                    placeholder="选择应用自动填充"
                  ></el-input>
                </el-form-item>
              </div>
            </li>
          </el-form>
        </ul>
      </div>
    </div>
    <div class="item-card">
      <div class="card-title">投放位置</div>
      <div class="card-content">
        <ul class="modal-form">
          <el-form :model="adAddress" :rules="addressRules" ref="addressRef">
            <li class="form-item">
              <span class="form-label" style="width: 90px">投放范围：</span>
              <div class="form-value">
                <el-radio-group v-model="adAddress.delivery_range" @change="changeManual">
                  <el-radio label="DEFAULT">默认</el-radio>
                  <el-radio label="UNION">穿山甲</el-radio>
                  <el-radio label="UNIVERSAL">通投智选</el-radio>
                </el-radio-group>
              </div>
            </li>
            <li class="form-item" v-show="adAddress.delivery_range === 'UNION'">
              <span class="form-label" style="width: 90px">投放形式：</span>
              <div class="form-value">
                <el-radio-group v-model="adAddress.union_video_type">
                  <el-radio label="ORIGINAL_VIDEO">原生视频</el-radio>
                  <el-radio label="REWARDED_VIDEO">激励视频</el-radio>
                  <el-radio label="SPLASH_VIDEO">穿山甲开屏</el-radio>
                </el-radio-group>
              </div>
            </li>
            <li class="form-item" v-show="adAddress.delivery_range === 'DEFAULT'">
              <span class="form-label" style="width: 90px; padding-top: 11px">广告位置：</span>
              <div class="form-value">
                <el-form-item prop="inventory_catalog" style="margin-bottom: 0px">
                  <el-radio-group @change="changeManual" v-model="adAddress.inventory_catalog">
                    <el-radio label="SMART">优选广告位</el-radio>
                    <el-radio label="MANUAL">
                      <el-dropdown trigger="click" :hide-on-click="false">
                        <span> 按媒体指定位置<i style="margin-left: 6px" class="el-icon-arrow-down"></i></span>
                        <el-dropdown-menu slot="dropdown">
                          <el-checkbox-group class="my-dropdown-select" v-model="adAddress.inventory_type" @change="changeManual">
                            <el-checkbox v-for="item in inventory_type_list" :key="item.value" :label="item.value">
                              <div class="my-dropdown-select-item">
                                <img class="img" :src="getImgUrl(item.icon)" />
                                <span class="label">{{ item.label }}</span>
                              </div>
                            </el-checkbox>
                          </el-checkbox-group>
                        </el-dropdown-menu>
                      </el-dropdown>
                    </el-radio>
                    <!-- <el-radio label="SCENE">
                      <el-dropdown trigger="click" :hide-on-click="false">
                        <span>
                          按场景指定位置<i
                            style="margin-left: 6px"
                            class="el-icon-arrow-down"
                          ></i
                        ></span>
                        <el-dropdown-menu slot="dropdown">
                          <el-radio-group
                            class="my-dropdown-select"
                            v-model="adAddress.scene_inventory"
                          >
                            <el-radio label="VIDEO_SCENE"
                              >沉浸式竖版视频场景</el-radio
                            >
                            <el-radio label="FEED_SCENE">信息流场景</el-radio>
                            <el-radio label="TAIL_SCENE"
                              >视频后贴和尾帧场景</el-radio
                            >
                          </el-radio-group>
                        </el-dropdown-menu>
                      </el-dropdown>
                    </el-radio> -->
                  </el-radio-group>
                </el-form-item>
              </div>
            </li>
            <div v-if="!(adAddress.delivery_range === 'UNION')">
              <!-- 搜索快投 -->
              <li class="form-item">
                <span class="form-label" style="width: 90px">搜索快投：</span>
                <div class="form-value">
                  <div class="search-wrap">
                    <div class="top-header">
                      <div class="cell-left">已选择关键词({{ wordsList.length }}/1000)</div>
                      <div class="cell-right">
                        <span class="btn-icon" @click="batchAdd">批量添加</span>
                        <span class="btn-icon" @click="wordsList = []">清空</span>
                      </div>
                    </div>
                    <div class="table-header">
                      <div class="cell-left">关键词</div>
                      <div class="cell-right">匹配方式</div>
                    </div>
                    <div class="table-content">
                      <div class="table-row" v-for="(item, index) of wordsList" :key="index">
                        <div class="cell-left">{{ item.keyword }}</div>
                        <div class="cell-right">
                          {{
                            item.match_type === "PHRASE"
                              ? "短语"
                              : item.match_type === "EXTENSIVE"
                              ? "广泛"
                              : item.match_type === "PRECISION"
                              ? "精确"
                              : "-"
                          }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </li>
              <li
                class="form-item"
                v-if="
                  budget_and_bid.length > 0 &&
                  budget_and_bid[0] &&
                  budget_and_bid[0].smart_bid_type !== 'SMART_BID_NO_BID' &&
                  tfContent.deep_external_action === 'NONE'
                "
              >
                <span class="form-label require" style="padding-top: 6px; width: 80px">出价系数：</span>
                <div class="form-value">
                  <el-form-item prop="search_bid_ratio" style="margin-bottom: 0px">
                    <el-input style="width: 400px" v-model="adAddress.search_bid_ratio" placeholder="请输入出价系数"></el-input>
                  </el-form-item>
                  <div style="font-size: 14px; color: #999; margin-top: 12px">
                    推荐出价系数 {{ recommendBid }}
                    <span style="color: #409eff; cursor: pointer; margin-left: 6px" @click="handleAccept">立即采纳</span>
                  </div>
                </div>
              </li>
              <li class="form-item">
                <span class="form-label" style="padding-top: 0px; width: 90px">定向扩展：</span>
                <div class="form-value">
                  <el-radio-group v-model="adAddress.audience_extend">
                    <el-radio label="ON">启用</el-radio>
                    <el-radio label="OFF">不启用</el-radio>
                  </el-radio-group>
                </div>
              </li>
            </div>
          </el-form>
        </ul>
      </div>
    </div>
    <!-- 人群包 -->
    <rqb ref="rqbRef"></rqb>
    <!-- 优化设置 -->
    <optimize-setting ref="optimizeRef"></optimize-setting>
    <!-- 落地页 -->
    <ldy ref="ldyRef"></ldy>
    <!-- 创意基础设置 -->
    <creative-baseset ref="creativeBasesetRef"></creative-baseset>
    <!-- 创意分类 -->
    <creative-classify ref="creativeClassifyRef"></creative-classify>
    <!-- 搜索快投弹框 -->
    <quick-launch ref="quickLaunchRef" @selectOk="selectOk"></quick-launch>
  </div>
</template>

<script>
import { mapState } from "vuex";
import Rqb from "./subBaseset/rqb.vue";
import OptimizeSetting from "./subBaseset/optimizeSetting.vue";
import Ldy from "./subBaseset/ldy.vue";
import CreativeBaseset from "./subBaseset/creativeBaseset.vue";
import CreativeClassify from "./subBaseset/CreativeClassify.vue";
import nameTransforUtil from "./common/nameTransforUtil.js";
import QuickLaunch from "./subBaseset/quickLaunchModal.vue";
import { feedAds, optimizedGoal, searchBid_ttV2 } from "@/api/promotion.js";
import { inventory_type_list } from "./subDirectpkg/optionData";
export default {
  components: {
    Rqb,
    OptimizeSetting,
    Ldy,
    CreativeBaseset,
    CreativeClassify,
    QuickLaunch,
  },
  data() {
    return {
      showMore: false,
      inventory_type_list,
      selectItem: [],
      adGroupList: [
        "投放范围",
        "广告位置",
        "投放形式",
        "下载方式",
        "创意分类",
        "开始时间",
        "创意组名称",
        "落地页",
        "投放方式",
        "试玩素材",
        "转化名称",
        "定向包",
        "标题包",
        "预算与出价",
        "创建日期",
        "首个视频名称",
        "首个图片名称",
        "账户备注名",
        "玩法名称",
        "素材日期",
        "组别",
      ],
      tfContent: {
        name_rule: "",
        download_type: "DOWNLOAD_URL",
        pricing: "PRICING_OCPM",
        convert_type: "",
        deep_external_action: "NONE",
        flowType: 0,
        package_name: "",
        app_type: "",
      },
      uniSelect: "",
      adAddress: {
        delivery_range: "DEFAULT",
        inventory_catalog: "SMART",
        union_video_type: "REWARDED_VIDEO",
        inventory_type: [],
        scene_inventory: "",
        //是否开启搜索快投
        searchToLaunch: 1,
        search_bid_ratio: "",
        audience_extend: "ON",
      },
      followData: [],
      allOptions: [],
      rules: {
        name_rule: [
          {
            required: true,
            message: "请输入广告计划名称",
            trigger: ["blur", "change"],
          },
        ],
        convert_type: [
          {
            required: true,
            message: "请选择转化目标",
            trigger: ["change"],
          },
        ],
        deep_external_action: [
          {
            required: true,
            message: "请选择深度转化目标",
            trigger: ["change"],
          },
        ],
        package_name: [
          {
            required: true,
            message: "请输入应用包名",
            trigger: ["blur", "change"],
          },
        ],
      },
      addressRules: {
        inventory_catalog: [
          {
            validator: (rule, value, callback) => {
              if (value === "MANUAL" && this.adAddress.inventory_type.length === 0) {
                callback(new Error("请勾选媒体指定位置"));
              } else if (value === "SCENE" && this.adAddress.scene_inventory == "") {
                callback(new Error("请勾选场景指定位置"));
              } else {
                callback();
              }
            },
            trigger: "change",
          },
        ],
        search_bid_ratio: [
          {
            validator: (rule, value, callback) => {
              if (!value) {
                callback(new Error("出价系数不能为空"));
              } else if (value < 1 || value > 2 || !/^(([1-9]{1}\d*)|(0{1}))(\.\d{1,2})?$/.test(value)) {
                callback(new Error("出价系数为1~2的数字，且最多两位小数"));
              } else {
                callback();
              }
            },
            trigger: "change",
          },
        ],
      },
      wordsList: [],
      converDataList: [], //转化相关数据
      deepConverList: [], //深度转化目标
      recommendBid: "",
    };
  },
  methods: {
    //弹框出现时查询表单数据(父组件调用),表单渲染
    initFormData() {
      this.initData();
      this.renderData();
      this.$refs.rqbRef.getListOption();
      this.$refs.optimizeRef.getListOption();
      this.$refs.creativeBasesetRef.initOptions();
      this.$refs.creativeClassifyRef.initOptions();
      this.$refs.ldyRef.initOptions();
    },
    initData() {
      //查询转化和深度转化
      if (this.converDataList.length === 0) {
        optimizedGoal({
          advertiserId: this.adCount.map((item) => item.advertiserId).join(),
          appType: this.app_type.replace("APP_", ""),
          pkg: this.app_pkg,
        }).then((res) => {
          if (res.code === "0000") {
            this.converDataList = res.optimizedGoalList;
            if (this.tfContent.convert_type) {
              this.changeTarget(this.tfContent.convert_type, false);
            }
          }
        });
      }

      //查询搜索快投的数据
      this.$nextTick(() => {
        if (this.wordsList.length === 0) {
          let advertiserIdList = this.adCount.map((item) => item.advertiserId).join();
          feedAds({
            advertiserId: advertiserIdList,
          }).then((res) => {
            if (res.code === "0000") {
              let resList = res.feedAdsList;
              this.wordsList = resList;
            }
          });
        }
      });
      // 获取推荐出价系数
      searchBid_ttV2({
        advertiserId: this.adCount[0].advertiserId,
      }).then((res) => {
        this.recommendBid = res.data;
      });
    },
    // 立即采纳出价系数
    handleAccept() {
      this.adAddress.search_bid_ratio = this.recommendBid;
    },
    getImgUrl(src) {
      return require(`./static/${src}.png`);
    },
    changeTarget(val, clear) {
      let curData = this.converDataList.find((item) => item.externalAction === val);
      if (curData) {
        this.deepConverList = curData.optimizedDeepGoalList;
      }
      if (clear) {
        this.tfContent.deep_external_action = "NONE";
      }
    },
    //弹框关闭保存数据到store(父组件调用)
    saveDataInStore() {
      this.saveInStore();
      this.$refs.rqbRef.saveInStore();
      this.$refs.optimizeRef.saveInStore();
      this.$refs.creativeBasesetRef.saveInStore();
      this.$refs.creativeClassifyRef.saveInStore();
      this.$refs.ldyRef.saveInStore();
    },
    //弹框关闭时校验数据格式
    checkData() {
      return Promise.all([
        this.checkCurData(),
        this.$refs.rqbRef.checkData(),
        this.$refs.optimizeRef.checkData(),
        this.$refs.ldyRef.checkData(),
        this.$refs.creativeBasesetRef.checkData(),
      ]);
    },
    handleSelectItem(item, itemIndex) {
      let index = this.selectItem.findIndex((item) => item === itemIndex);
      if (index === -1) {
        this.selectItem.push(itemIndex);
        this.tfContent.name_rule += "{" + item + "}";
      } else {
        this.selectItem.splice(index, 1);
        this.tfContent.name_rule = this.tfContent.name_rule.replace("{" + item + "}", "");
      }
    },
    saveInStore() {
      //将表单数据转为接口用数据
      let data = JSON.parse(JSON.stringify(this.tfContent));
      data.app_type = this.app_type;
      let convert = [];
      //分别配置
      if (data.flowType === 0) {
        for (let [{ advertiserId, selectVal }, optionList] of this.followData) {
          let curItem = optionList.find((item) => item.convert_id === selectVal);
          convert.push({
            account_id: advertiserId,
            convert_id: selectVal,
            label: curItem ? curItem.name : "",
          });
        }
      } else {
        //统一配置
        for (let [{ advertiserId }, optionList] of this.followData) {
          let curItem = optionList.find((item) => item.convert_id === this.uniSelect);
          convert.push({
            account_id: advertiserId,
            convert_id: this.uniSelect,
            label: curItem ? curItem.name : "",
          });
        }
      }
      data.convert = convert;
      this.$store.commit("set_promote_object", data);
      this.$store.commit("set_name_rule", nameTransforUtil.showDataToApi(data.name_rule));
      this.saveDeliveryData();
    },
    //保存投放位置数据
    saveDeliveryData() {
      //投放位置数据
      let storeData = {
        delivery_range: this.adAddress.delivery_range,
      };
      //默认
      if (storeData.delivery_range === "DEFAULT") {
        storeData.inventory_catalog = this.adAddress.inventory_catalog;
        if (this.adAddress.inventory_catalog === "SMART") {
          //优选广告位
          storeData.smart_inventory = "SMART";
        } else if (this.adAddress.inventory_catalog === "MANUAL") {
          //首选媒体
          storeData.inventory_type = this.adAddress.inventory_type;
        } else if (this.adAddress.inventory_catalog === "SCENE") {
          //按场景指定
          storeData.scene_inventory = this.adAddress.scene_inventory;
        }
        //穿山甲
      } else if (storeData.delivery_range === "UNION") {
        storeData.union_video_type = this.adAddress.union_video_type;
      }
      //按场景指定
      storeData.search_bid_ratio = this.adAddress.search_bid_ratio || null;
      storeData.searchToLaunch = this.adAddress.searchToLaunch;
      storeData.audience_extend = this.adAddress.audience_extend;

      //是否开启搜索快投
      if (this.adAddress.searchToLaunch === 1) {
        storeData.feedAdsList = this.wordsList;
      }
      this.$store.commit("set_delivery_placement", storeData);
    },
    //数据渲染
    renderData() {
      //投放内容
      if (this.promote_object) {
        let value = JSON.parse(JSON.stringify(this.promote_object));
        //将接口数据转为表单用数据
        let storeVal = JSON.parse(JSON.stringify(value));
        //         convert_type
        // deep_external_action
        this.tfContent = storeVal;
      }

      //投放位置
      if (this.delivery_placement) {
        let value = JSON.parse(JSON.stringify(this.delivery_placement));
        this.adAddress.delivery_range = value.delivery_range;
        this.adAddress.inventory_catalog = value.inventory_catalog || "SMART";
        this.adAddress.union_video_type = value.union_video_type || "REWARDED_VIDEO";
        this.adAddress.inventory_type = value.inventory_type || [];
        this.adAddress.scene_inventory = value.scene_inventory || "";
        this.adAddress.search_bid_ratio = value.search_bid_ratio;
        this.adAddress.audience_extend = value.audience_extend || "ON";
        //搜索快投是否打开
        if (value.feedAdsList) {
          this.adAddress.searchToLaunch = 1;
          this.wordsList = value.feedAdsList;
        } else {
          this.adAddress.searchToLaunch = 0;
          this.wordsList = [];
        }
      }

      //广告计划名称
      if (this.name_rule) {
        this.tfContent.name_rule = nameTransforUtil.apiDatatoShow(this.name_rule);
        this.selectItem = [];
        this.adGroupList.map((item, index) => {
          if (this.tfContent.name_rule.includes(`{${item}}`)) {
            this.selectItem.push(index);
          }
        });
      }

      //赋值包名
      if (this.checkedApp && this.checkedApp.package_name) {
        this.tfContent.package_name = this.checkedApp.package_name;
      }
    },
    //校验投放内容的数据格式
    checkCurData() {
      return Promise.all([
        //投放内容
        new Promise((resolve, reject) => {
          this.$refs.tfcontentRef.validate((valid) => {
            if (valid) {
              resolve();
            } else {
              reject();
            }
          });
        }),
        //投放位置
        new Promise((resolve, reject) => {
          this.$refs.addressRef.validate((valid) => {
            if (valid) {
              resolve();
            } else {
              reject();
            }
          });
        }),
      ]);
    },
    //媒体位置包含抖音时启用推广卡片
    changeManual() {
      if (this.adAddress.delivery_range === "DEFAULT" && this.adAddress.inventory_catalog === "MANUAL") {
        let excludeDY = this.adAddress.inventory_type.find((item) => item === "INVENTORY_AWEME_FEED");
        if (excludeDY) {
          this.$refs.creativeBasesetRef.onlyCard = true;
          this.$refs.creativeBasesetRef.formData.promotion_card = "1";
        } else {
          this.$refs.creativeBasesetRef.onlyCard = false;
          this.$refs.creativeBasesetRef.formData.promotion_card = "0";
        }
      } else {
        this.$refs.creativeBasesetRef.onlyCard = false;
        this.$refs.creativeBasesetRef.formData.promotion_card = "0";
      }

      //穿山甲时不能开启搜索快投
      if (this.adAddress.delivery_range === "UNION") {
        this.adAddress.searchToLaunch = 0;
      }

      this.saveDeliveryData();
    },
    //搜索快投
    batchAdd() {
      this.$refs.quickLaunchRef.showModal();
    },
    selectOk(data) {
      data.wordList.forEach((key) => {
        if (this.wordsList.length < 1000) {
          this.wordsList.push({
            match_type: data.match_type,
            keyword: key,
          });
        }
      });
    },
  },
  computed: {
    showAdList() {
      if (!this.showMore) {
        return this.adGroupList.slice(0, 5);
      }
      return this.adGroupList;
    },
    ...mapState({
      adCount: (state) => state.Promotion.adCount,
      promote_object: (state) => state.Promotion.draft_adset.promote_object,
      budget_and_bid: (state) => state.Promotion.draft_adset.budget_and_bid,
      delivery_placement: (state) => state.Promotion.draft_adset.delivery_placement,
      name_rule: (state) => state.Promotion.draft_adset.name_rule,
      app_type: (state) => {
        let type = state.Promotion.checkedApp.os_type;
        return type ? "APP_" + type : "";
      },
      app_pkg: (state) => {
        return state.Promotion.checkedApp.package_name || null;
      },
      checkedApp: (state) => state.Promotion.checkedApp,
    }),
  },
};
</script>

<style lang="less" scoped>
.edit-wrap {
  height: calc(100vh - 63px);
  box-sizing: border-box;
  background: rgba(228, 232, 239, 1);
  border-top: 1px solid rgba(0, 0, 0, 0.2);
  overflow: auto;
  .item-card {
    background-color: #fff;
    padding: 24px;
    margin-bottom: 6px;
    .card-title {
      font-size: 14px;
      color: rgba(0, 0, 0, 0.85);
      font-weight: bold;
    }
  }
  // .item-card:not(:last-child) {
  //   margin-bottom: 6px;
  // }
  .card-content {
    margin-top: 20px;
    .modal-form {
      margin: 0px;
      padding: 0px;
      list-style: none;
      .form-item {
        display: flex;
        margin-bottom: 20px;
        .form-label {
          flex-shrink: 0;
          display: inline-block;
          width: 130px;
          text-align: right;
          font-size: 14px;
          color: rgba(0, 0, 0, 0.65);
          // padding-top: 6px;
          &.require::before {
            content: "*";
            display: inline-block;
            color: red;
            margin-right: 4px;
          }
        }
        .form-value {
          width: 100%;
          padding-top: 2px;
          /deep/ .el-radio__input.is-checked .el-radio__inner {
            color: rgba(24, 144, 255, 1);
            border-color: rgba(24, 144, 255, 1);
            background: rgba(24, 144, 255, 1);
          }
          /deep/ .el-radio__input.is-checked + .el-radio__label {
            color: rgba(0, 0, 0, 0.65);
          }
          .name-list {
            padding: 12px 0px 0px 0px;
            margin: 0px;
            list-style: none;
            display: flex;
            flex-wrap: wrap;
            .name-item {
              border-radius: 2px;
              border: 1px solid transparent;
              box-sizing: border-box;
              background: rgba(233, 233, 233, 0.6);
              color: rgba(0, 0, 0, 0.85);
              font-size: 12px;
              padding: 2px 6px;
              margin: 0 8px 8px 0px;
              cursor: pointer;
              &.cur {
                border: 1px solid rgba(24, 144, 255, 1);
                background: rgba(225, 240, 255, 1);
                color: rgba(24, 144, 255, 1);
              }
            }
            .show-more {
              color: rgba(24, 144, 255, 1);
              font-size: 13px;
              cursor: pointer;
              margin-left: 20px;
              line-height: 24px;
              i {
                margin-left: 4px;
              }
            }
          }
          .flow-table-wrap {
            margin-top: 12px;
            /deep/ th {
              height: 33px;
              padding: 2px 0;
            }
            /deep/ .el-table td,
            .el-table th {
              padding: 2px 0;
            }
            .header-wrap {
              display: flex;
              .transfor-manage {
                margin-left: auto;
                font-size: 12px;
                color: #409eff;
                cursor: pointer;
              }
            }
          }
          .search-wrap {
            margin-top: 12px;
            width: 400px;
            border: 1px solid #eee;
            border-radius: 4px;
            .top-header {
              height: 32px;
              background-color: #f5f6f7;
              border-bottom: 1px solid #eee;
            }
            .table-header {
              height: 32px;
              border-bottom: 1px solid #eee;
            }
            .table-content {
              min-height: 100px;
              max-height: 300px;
              overflow: auto;
              .table-row {
                .cell-right {
                  width: 120px;
                }
                &:hover {
                  background-color: #f5f6f7;
                }
              }
            }
            .cell-left {
              height: 100%;
              width: 258px;
              display: inline-block;
              line-height: 32px;
              font-size: 12px;
              padding: 0 10px;
              box-sizing: border-box;
            }
            .cell-right {
              height: 100%;
              width: 142px;
              display: inline-block;
              line-height: 32px;
              font-size: 12px;
              .btn-icon {
                color: #0b75ff;
                margin-right: 10px;
                cursor: pointer;
              }
            }
          }
        }
      }
    }
  }
}
.el-dropdown-menu {
  /deep/.my-dropdown-select {
    width: 200px;
    padding-left: 10px;
    .el-checkbox {
      display: block;
      line-height: 30px;
    }
    .el-radio {
      display: block;
      line-height: 26px;
      .el-radio__input.is-checked .el-radio__inner {
        color: rgba(24, 144, 255, 1);
        border-color: rgba(24, 144, 255, 1);
        background: rgba(24, 144, 255, 1);
      }
      .el-radio__input.is-checked + .el-radio__label {
        color: rgba(24, 144, 255, 1);
      }
    }
    .my-dropdown-select-item {
      line-height: 30px;
      .img {
        height: 30px;
        width: 30px;
        position: relative;
        top: 10px;
        left: 3px;
      }
      .label {
        margin-left: 14px;
      }
    }
  }
}
</style>
